import './style.scss';
import $ from 'jQuery';

$(document).ready(function() {
	if (window.outerWidth >= 639) {
       
        /* Equalise the post title */
        if ($(".wp-blt-block-post-listing .post-listing-item_title-container").length > 1) {
            var highestBox = 0;
            $(".wp-blt-block-post-listing .post-listing-item_title-container", this).each(function () {
                if ($(this).height() > highestBox) {
                    highestBox = $(this).height();
                }
            });
            $(".wp-blt-block-post-listing .post-listing-item_title-container", this).height(highestBox);
        }

        /* Equalise the post excerpt */
        if ($(".wp-blt-block-post-listing .post-listing-item_excerpt-container").length > 1) {
            var highestBox = 0;
            $(".wp-blt-block-post-listing .post-listing-item_excerpt-container", this).each(function () {
                if ($(this).height() > highestBox) {
                    highestBox = $(this).height();
                }
            });
            $(".wp-blt-block-post-listing .post-listing-item_excerpt-container", this).height(highestBox);
        }
        
    }
})
